'use client';

import type React from 'react';
import { createContext, useContext, useMemo } from 'react';

type SavedInterfaceVersionDetailsType = {
  currentVersion: number;
  // Component (page) entity's own version at the snapshot — distinct from interface version.
  // Embedded-entities API expects the root component's version, not the interface's.
  componentVersion?: number;
};

export const SavedInterfaceVersionDetailsContext =
  createContext<SavedInterfaceVersionDetailsType | null>(null);

export const useSavedInterfaceVersionDetails = () => {
  const context = useContext(SavedInterfaceVersionDetailsContext);
  if (context === null) {
    throw new Error('SavedInterfaceVersionDetails not found');
  }
  return context;
};

export function SavedInterfaceVersionDetailsProvider({
  currentVersion,
  componentVersion,
  children,
}: {
  currentVersion: number;
  componentVersion?: number;
  children: React.ReactNode;
}) {
  const value = useMemo(
    () => ({
      currentVersion,
      componentVersion,
    }),
    [currentVersion, componentVersion],
  );

  return (
    <SavedInterfaceVersionDetailsContext.Provider value={value}>
      {children}
    </SavedInterfaceVersionDetailsContext.Provider>
  );
}
